import { useRef, useEffect } from 'react';

const useLatestRef = value => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  });

  return ref;
};

export default useLatestRef;
